import { requireStates } from "util";

const initialStates = [
  {
    name: "app.registration.product.inventory",
    url: "/estoque",
    abstract: true
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/index.js